<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 14091 14091"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="14091" height="14091" rx="1374" ry="1374"/>
  <path class="fil1" d="M1190 9361l11711 0 0 2357c0,628 -515,1142 -1142,1142l-9427 0c-628,0 -1142,-514 -1142,-1142l0 -2357z"/>
  <g id="_819505872">
   <path class="fil1" d="M9544 2766c-948,1 -1459,-113 -1948,494 -216,269 -259,543 -259,958 0,407 10,826 0,1232l256 16 961 1 257 -15 -2 -1214 3957 1 -1 -1476c-1805,5 -1016,0 -3221,3z"/>
   <path class="fil1" d="M8067 8730c146,0 253,-9 387,-61 189,-73 339,-177 463,-343 40,-53 82,-114 110,-179 103,-242 132,-474 46,-729 -83,-248 -227,-441 -378,-643l-440 -588c-58,-93 -75,-153 -151,-153 -62,0 -98,82 -140,150 -58,97 -313,431 -404,543 -157,191 -339,461 -414,687 -78,234 -63,443 20,674 45,128 168,302 270,387 112,94 189,140 324,193 19,7 37,13 55,19 62,20 172,43 252,43z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'WaterSupply',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3}
</style>
